import React from "react";

import classNames from "classnames";
import { useFormikContext } from "formik";
import { Accordion, Card } from "react-bootstrap";
import { IDeemedCapitalGains } from "../../../../config/interfaces";
import { SwitchBtnContextAwareToggle } from "../../../accordion";
import { FormField, NumericInputField, SelectInputField } from "../../../fields";

type Props = {};

const CGDeemedForm: React.FC<Props> = (props: Props) => {
  const {} = props;

  const { values, errors, touched, setFieldValue, handleBlur } =
    useFormikContext<IDeemedCapitalGains>();

  return (
    <>
      <section className="mb-5">
        <Accordion flush activeKey={values.shTermCapitalGains ? "0" : "1"}>
          <Card className="more-info-card shadow-none mb-5 overflow-hidden">
            <Card.Header className={classNames(!values?.shTermCapitalGains && "border-0")}>
              <Card.Title>
                Short Term Capital Gains
                <SwitchBtnContextAwareToggle
                  eventKey="0"
                  name="shTermCapitalGains"
                  onChange={(checked: boolean) => {
                    setFieldValue("shTermCapitalGains", checked);
                    setFieldValue("shUnutilizedCapitalGains", "");
                    setFieldValue("shOtherDeemedAmount", "");
                    setFieldValue("shDeemedTotalAmount", "");
                  }}
                />
              </Card.Title>
            </Card.Header>
            <Accordion.Collapse eventKey="0">
              <>
                <Card.Body>
                  <FormField
                    label="Whether any amount of unutilized capital gain on asset transferred during the previous years shown below was deposited in the Capital Gains Accounts Scheme within due date for that year?"
                    sm={4}
                    isRequired={true}
                  >
                    <SelectInputField
                      name="shUnutilizedCapitalGains"
                      isOptionArrayOfObject={false}
                      options={["Yes", "No", "Not Applicable"]}
                      value={[values.shUnutilizedCapitalGains]}
                      onChange={(_unutilizedCapitalGains) => {
                        if (_unutilizedCapitalGains) {
                          setFieldValue("shUnutilizedCapitalGains", _unutilizedCapitalGains.value);
                        } else {
                          setFieldValue("shUnutilizedCapitalGains", undefined);
                        }
                      }}
                      onBlur={handleBlur("shUnutilizedCapitalGains")}
                      isInvalid={
                        Boolean(errors.shUnutilizedCapitalGains) && touched.shUnutilizedCapitalGains
                      }
                      errorMsg={errors.shUnutilizedCapitalGains}
                    />
                  </FormField>

                  <FormField
                    label="Any other amount deemed to be short term capital gain"
                    sm={4}
                    isRequired={true}
                  >
                    <NumericInputField
                      showLeftIcon={true}
                      placeholder=""
                      name="shOtherDeemedAmount"
                      value={values.shOtherDeemedAmount}
                      onChange={(value) => {
                        setFieldValue("shOtherDeemedAmount", value);
                        setFieldValue("shDeemedTotalAmount", value);
                      }}
                      onBlur={handleBlur("shOtherDeemedAmount")}
                      isInvalid={Boolean(errors.shOtherDeemedAmount) && touched.shOtherDeemedAmount}
                      errorMsg={errors.shOtherDeemedAmount}
                    />
                  </FormField>

                  <FormField label="Total amount deemed to be short term capital gains" sm={4}>
                    <NumericInputField
                      showLeftIcon={true}
                      placeholder=""
                      name="shDeemedTotalAmount"
                      value={values.shDeemedTotalAmount}
                      onChange={(value) => setFieldValue("shDeemedTotalAmount", value)}
                      onBlur={handleBlur("shDeemedTotalAmount")}
                      isInvalid={Boolean(errors.shDeemedTotalAmount) && touched.shDeemedTotalAmount}
                      errorMsg={errors.shDeemedTotalAmount}
                      isDisabled={true}
                    />
                  </FormField>
                </Card.Body>
              </>
            </Accordion.Collapse>
          </Card>
        </Accordion>
        <Accordion flush activeKey={values.loTermCapitalGains ? "0" : "1"}>
          <Card className="more-info-card shadow-none mb-5 overflow-hidden">
            <Card.Header className={classNames(!values?.loTermCapitalGains && "border-0")}>
              <Card.Title>
                Long Term Capital Gains
                <SwitchBtnContextAwareToggle
                  eventKey="0"
                  name="loTermCapitalGains"
                  onChange={(checked: boolean) => {
                    setFieldValue("loTermCapitalGains", checked);
                    setFieldValue("loUnutilizedCapitalGains", "");
                    setFieldValue("loOtherDeemedAmount", "");
                    setFieldValue("loDeemedTotalAmount", "");
                  }}
                />
              </Card.Title>
            </Card.Header>
            <Accordion.Collapse eventKey="0">
              <>
                <Card.Body>
                  <FormField
                    label="Whether any amount of unutilized capital gain on asset transferred during the previous years shown below was deposited in the Capital Gains Accounts Scheme within due date for that year?"
                    sm={4}
                    isRequired={true}
                  >
                    <SelectInputField
                      placeholder="loUnutilizedCapitalGains"
                      name="loUnutilizedCapitalGains"
                      isOptionArrayOfObject={false}
                      options={["Yes", "No", "Not Applicable"]}
                      value={[values.loUnutilizedCapitalGains]}
                      onChange={(_unutilizedCapitalGains) => {
                        if (_unutilizedCapitalGains) {
                          setFieldValue("loUnutilizedCapitalGains", _unutilizedCapitalGains.value);
                        } else {
                          setFieldValue("loUnutilizedCapitalGains", undefined);
                        }
                      }}
                      onBlur={handleBlur("loUnutilizedCapitalGains")}
                      isInvalid={
                        Boolean(errors.loUnutilizedCapitalGains) && touched.loUnutilizedCapitalGains
                      }
                      errorMsg={errors.loUnutilizedCapitalGains}
                    />
                  </FormField>

                  <FormField
                    label="Any other amount deemed to be short term capital gain"
                    sm={4}
                    isRequired={true}
                  >
                    <NumericInputField
                      showLeftIcon={true}
                      placeholder=""
                      name="loOtherDeemedAmount"
                      value={values.loOtherDeemedAmount}
                      onChange={(value) => {
                        setFieldValue("loOtherDeemedAmount", value);
                        setFieldValue("loDeemedTotalAmount", value);
                      }}
                      onBlur={handleBlur("loOtherDeemedAmount")}
                      isInvalid={Boolean(errors.loOtherDeemedAmount) && touched.loOtherDeemedAmount}
                      errorMsg={errors.loOtherDeemedAmount}
                    />
                  </FormField>

                  <FormField label="Total amount deemed to be short term capital gains" sm={4}>
                    <NumericInputField
                      showLeftIcon={true}
                      placeholder=""
                      name="loDeemedTotalAmount"
                      value={values.loDeemedTotalAmount}
                      onChange={(value) => setFieldValue("loDeemedTotalAmount", value)}
                      onBlur={handleBlur("loDeemedTotalAmount")}
                      isInvalid={Boolean(errors.loDeemedTotalAmount) && touched.loDeemedTotalAmount}
                      errorMsg={errors.loDeemedTotalAmount}
                      isDisabled={true}
                    />
                  </FormField>
                </Card.Body>
              </>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </section>
    </>
  );
};

export default CGDeemedForm;
